import React from "react";
import './projectList.scss'
import Project from "../project/project";
import TechnicalSkillList from "../technicalSkillsList/technicalSkillList";
import { Navigate } from "react-router-dom";
let self;

export class ProjectList extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        self = this;
        this.state = { noOfProject: 1, projectList: [], isProjectAdditingDone: false, profileData: {} }
    }

    onProjectAdded(data, isNext) {
        // console.log(data, isNext)

        let newData;
        if (isNext) {
            self.setState({ noOfProject: self.state.noOfProject + 1 })
        } else {
            self.setState({ isProjectAdditingDone: true })
            const data1: any = sessionStorage.getItem('portfolioForm')
            const previousData = JSON.parse(data1);
            newData = { ...previousData, projectList: [...self.state.projectList, data] }
            sessionStorage.setItem('portfolioForm', JSON.stringify(newData))
        }
        self.setState({ projectList: [...self.state.projectList, data] });
        self.setState({ profileData: newData });
    }
    render(): React.ReactNode {
        return (
            <>
                {!this.state.isProjectAdditingDone &&
                    <div className="form__wrapper">
                        {
                            Array.from({ length: this.state.noOfProject }).map((e, i) => {
                                return <Project onProjectAdded={this.onProjectAdded} key={i} projectNo={i + 1}></Project>
                            })
                        }
                    </div>
                }
                {
                    this.state.isProjectAdditingDone &&
                    <Navigate to="/technical-skill-list" replace={true} />
                }
            </>
        )
    }
}

export default ProjectList;